import React from "react";
import styled from "styled-components";
import { MaterialIcon } from "@loanbossinc/component-library";

import { DASHBOARD_VIEW_OPTION_TYPES } from "../../constants";

const CellWrapper = styled.div`
    border: 1px solid #DADCE0;
    border-radius: 8px;
    padding: 1em 2em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: #005AA9;
`;

const NameTextLink = styled.div`
  cursor: pointer;
`;

const StatusDeleteWrapper = styled.div`
    display: inherit;
    flex-direction: inherit;
    gap: 1em;
`;

const StatusText = styled.div`
    color: #5F6368;
`;

const CampaignCell = ({ id, name, statusMessage, setDeleteCampaignDialogOpened, setSelectedCampaignIdForDeletion, selectedDashboardView, selectCampaign }) => (
  <CellWrapper>
    <NameTextLink onClick={() => selectCampaign(id)}>{name}</NameTextLink>
    <StatusDeleteWrapper>
      <StatusText>{statusMessage}</StatusText>
      {
        selectedDashboardView !== DASHBOARD_VIEW_OPTION_TYPES.COMPLETED.value &&
          <MaterialIcon
            onClick={() => {
              setDeleteCampaignDialogOpened(true);
              setSelectedCampaignIdForDeletion(id);
            }}
            iconName="delete_outline"
            style={{ color: "#005AA9", cursor: "pointer" }}
          />
      }
    </StatusDeleteWrapper>
  </CellWrapper>
);

export default CampaignCell;
